<script>
import searchable from '@/modules/searcher/mixins/searchable';

export default {
  name: 'nx-renderless-searcher',
  mixins: [searchable],
  props: {
    entity: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
    },
    limit: {
      type: Number,
    },
  },
  methods: {
    appendItem(item) {
      this.items.push(item);
    },
  },
  render(h) {
    return this.$scopedSlots.default({
      loading: this.loading,
      items: this.items,
      page: this.page,
      numPages: this.numPages,
      numResults: this.numResults,
      hasMorePages: this.hasMorePages,
      hasResults: this.numResults > 0,
      loadMore: this.loadMore,
    });
  },
};
</script>
